module.exports = [{"type":"title","text":"2025-01-21"},{"type":"normal","text":"","style":{"font-weight":"bold"},"children":[{"type":"html","text":"永續U本位：查詢所有掛單接口增加Price字段和PriceRate字段描述"}]}]


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/changelog/2025-01-21.json
// module id = GWmm
// module chunks = 3